import { classNames } from '@library/utils';

interface LoadingProps {
  loadingMessage: string;
  className?: string;
  messageClassName?: string;
}

export const Loading = ({
  loadingMessage,
  className = 'py-10',
  messageClassName = ''
}: LoadingProps) => (
  <div
    className={classNames(
      'text-soClean-100 flex flex-col items-center justify-center self-center',
      className
    )}
    data-testid="loading-element"
  >
    <span
      className={classNames(loadingMessage ? 'pt-4' : '', messageClassName)}
    >
      {loadingMessage}
    </span>
    <div
      className="mt-2 inline-block size-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
      role="status"
    >
      <span className="text-soClean-100 !absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  </div>
);
